<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ReviewResolveModal',
})
</script>
<template>
  <Modal v-model:visible="visible" centered destroy-on-close title="同意" width="600px" :confirm-loading="submitLoading" @ok="submit">
    <div class="ant-modal-bd">
      <Form ref="formRef" layout="vertical" label-align="left" :model="model" scroll-to-first-error class="ant-edit-form">
        <FormItem label="审核意见" name="shenHeYiJian" :rules="getRequiredRule('审核意见')">
          <Input.TextArea v-model:value="model.shenHeYiJian" placeholder="请输入" allowClear :autoSize="{ minRows: 4, maxRows: 8 }" />
        </FormItem>
        <FormItem label="附件" v-if="fileVisible">
          <FileUpload v-model:value="model.files!.fuJian" :filesCol="{ span: 24 }" />
        </FormItem>
      </Form>
    </div>
  </Modal>
</template>

<script lang="ts" setup name="ReviewResolveModal">
import { Modal, Form, Input, message } from 'ant-design-vue'
import { ref } from 'vue'
import { FormItem } from '-/Common/Form'
import { FileUpload } from '-/Common/FileUpload'
import { getRequiredRule } from '@/constant/form'
import { handleFormError } from '@/hooks/useForm'
import { API_REVIEW_ADD } from '@/api/review'
const props = withDefaults(
  defineProps<{
    fileVisible?: boolean
  }>(),
  {
    fileVisible: true
  }
)
const emits = defineEmits<{
  (e: 'refresh'): void
}>()
const visible = ref(false)
const formRef = ref()
const submitLoading = ref(false)
const model = ref<Partial<ApiReview.Item>>({})

const close = () => {
  visible.value = false
  formRef.value?.resetFields?.()
  emits('refresh')
}

const sourceId = ref<string>()
const statusNum = ref<number>(1)
const statusType = ref<number>()
const open = (_sourceId: string, _statusNum = 1, _statusType = 0) => {
  visible.value = true
  sourceId.value = _sourceId
  statusNum.value = _statusNum
  statusType.value = _statusType
  model.value = {
    shenHeYiJian: '同意'
  }
  if (props.fileVisible) {
    model.value.files = {
      fuJian: []
    }
  }
}
defineExpose({
  open
})

const submit = async () => {
  if (submitLoading.value) return

  submitLoading.value = true
  try {
    await formRef.value?.validate?.()
    const params: any = {
      ...model.value,
      sourceId: sourceId.value,
      isAgree: statusNum.value,
      sourceType: statusType.value
    }
    await API_REVIEW_ADD(params)
    message.success('操作成功')
    close()
  } catch (err) {
    handleFormError(err)
  } finally {
    submitLoading.value = false
  }
}
</script>
